<template>
  <Typography.Link v-bind="getBindValue">{{ getBindValue.text }}</Typography.Link>
</template>

<script setup lang="ts">
  import { Typography } from 'ant-design-vue';
  import { computed, useAttrs } from 'vue';
  import type { TargetContext } from '@mts-fe/types';
  import { isHttpUrl, omit, replaceUrl } from '@mts-fe/utils';
  import type { CellProps } from '../../types/table';

  defineOptions({
    name: 'RenderLink',
    inheritAttrs: false,
  });

  interface LinkColumnRender {
    textKey?: string;
    text?: string;
    href?: string;
    hrefKey?: string;
    target?: TargetContext;
  }
  const props = withDefaults(defineProps<CellProps & { render: LinkColumnRender }>(), {});

  const getRenderProps = (render = props.render, record = props.record) => {
    const href = render.hrefKey
      ? replaceUrl(record[render.hrefKey], record) || render.hrefKey
      : render.href
        ? replaceUrl(render.href, record)
        : render.href || '';
    return {
      ...render,
      target: render.target || '_self',
      href: isHttpUrl(href) ? href : '/#' + href.replace('/#', ''),
      disabled: !href,
      text: render.textKey
        ? record[render.textKey] || render.textKey
        : render.text || record[props.column.dataIndex!.toString()!] || '-',
    };
  };

  const attrs = useAttrs();
  const getBindValue = computed(() => {
    return { ...attrs, ...omit(getRenderProps(), ['hrefKey', 'textKey']) };
  });
</script>
